const s = (o) => ({
  input: ({
    onChange: a
  }) => ({
    accept: "application/JSON",
    multiple: !1,
    onChange: (t) => {
      const n = (t.target.files || [])[0], e = new FileReader();
      e.onloadend = () => {
        try {
          if (!e.result)
            throw new Error("File is not a valid JSON");
          const r = JSON.parse(e.result), i = JSON.stringify(r, null, 4);
          if (!i)
            throw new Error("File is not a valid JSON");
          const l = {
            ...t,
            target: {
              ...t.target,
              value: i
            }
          };
          a?.(l);
        } catch (r) {
          o?.(r);
        }
      }, e.readAsText(n);
    },
    type: "file"
  }),
  root: {
    sx: {
      alignItems: "center"
    }
  }
});
export {
  s as g
};
//# sourceMappingURL=index._aEPM5Ps.js.map
